export default {
	container: {
		display: 'flex',
		width: '110px',
		float: 'right',
		marginRight: '20px'
	},
	noti: {
		flex: '1',
		textAlign: 'center'
	},
	avatar: {
		flex: '1',
		textAlign: 'center'
	}
};
